module.exports = __webpack_public_path__ + "img/6.65948142.png";